import { Trans, useTranslation } from 'react-i18next';
import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import clsx from 'clsx';

import { IconMedal } from '@/assets/pro';
import { useCurrentAddressInfo } from '@/hooks';
import { login } from '@/utils';

import { Loading } from '../Loading';
import Button from '../Button';
import './index.scss';
import ReactGA4 from 'react-ga4';
import { useUserType } from '@/hooks/useUserType';
import { getModuleFromLocation, getSourceForGAByModulePage } from '@/utils/common';
interface JoinProProps {
  className?: string;
  style?: React.CSSProperties;
  proContent?: React.ReactNode;
  enabled?: boolean;
  isLoading: boolean;
}

export const JoinPro = (props: JoinProProps) => {
  const { t } = useTranslation();

  const { className, style, proContent, enabled, isLoading } = props;

  const { address, isVerified } = useCurrentAddressInfo();

  const history = useHistory();
  const location = useLocation();
  const userType = useUserType();

  const handleClick = useCallback(() => {
    if (!isVerified) {
      login();

      return;
    }

    if (userType) {
      ReactGA4.event({
        category: 'Debank Pro',
        action: 'View Pro Features Page',
        label: `${userType}|${getSourceForGAByModulePage(getModuleFromLocation())}`,
      });
    }

    history.push('/paid');
  }, [history, isVerified, userType]);

  const isLogin = isVerified && address;

  useEffect(() => {
    if (!enabled) {
      const key = location.pathname.split('/')[1];
      const dict: Record<string, string> = {
        bundles: 'Bundles',
        analysis: 'Profile Time Machine',
        whales: 'Whales',
        tokens: 'Tokens',
        protocols: 'Protocols',
        nfts: 'NFTs',
      };
      const name = dict[key];
      if (name) {
        ReactGA4.event({
          category: 'Debank Pro',
          action: 'Pay Wall Page',
          label: `${name}|${isLogin ? 'Common' : 'Visit'}`,
        });
      }
    }
  }, [isLogin, enabled, location.pathname]);

  return (
    <>
      {enabled ? (
        proContent
      ) : isLoading ? (
        <Loading className="db-join-pro-loading" />
      ) : (
        <div className={clsx(className, 'db-join-pro-card')} style={style}>
          <div>
            <img src={IconMedal} className="db-join-pro-card-icon" alt="" />
            <h5 className="db-join-pro-card-title">
              <Trans i18nKey="JoinPro.5k1i1u">
                This is a DeBank
                <strong>Paid Feature</strong>
              </Trans>
            </h5>
            <p className="db-join-pro-card-desc"></p>
            <Button type="primary" className="db-join-pro-card-btn" onClick={handleClick}>
              {isVerified ? t('JoinPro.learnMore') : t('JoinPro.login')}
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
